// utils/auth.js
export const redirectToWeChatAuth=(goodsId)=>{
  const appid = 'wx099747290fa3b1fa';
  const redirect_uri = encodeURIComponent(window.location.href);
  const response_type = 'code';
  const scope = 'snsapi_base'; // 或 snsapi_base
  const state = goodsId; // 可自定义用于验证

  const url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirect_uri}&response_type=${response_type}&scope=${scope}&state=${state}#wechat_redirect`;

  window.location.href = url;
}